import {useEnabledFeatures} from '../../../hooks/use-enabled-features'
import {getGroupIdFromQueryKey} from './query-keys'
import {usePaginatedMemexItemsQuery} from './use-paginated-memex-items-query'

export function useHasMoreItems() {
  const {memex_table_without_limits} = useEnabledFeatures()
  if (!memex_table_without_limits) return false
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const {hasNextPage, hasNextPageForGroup, queryKeysForItems} = usePaginatedMemexItemsQuery()
  // If the data isn't grouped, we can simply check the `hasNextPage` value which should indicate
  // whether or not there is more data on the server.
  if (hasNextPage) {
    return true
  }

  // Otherwise, we need to check individual groups to see if at least one of them has more data on the server
  // We extract the groupId from each query key and see if it has a next page.
  const groupIds = new Set<string>()
  for (const queryKeyForItem of queryKeysForItems) {
    const groupId = getGroupIdFromQueryKey(queryKeyForItem)
    if (groupId != null) {
      if (!groupIds.has(groupId) && hasNextPageForGroup(groupId)) {
        return true
      }
      // Go ahead and add the groupId to a set so that we don't check it again.
      groupIds.add(groupId)
    }
  }

  return false
}
